import { defineComponent as t, createBlock as n, openBlock as l, unref as a, mergeProps as c, withCtx as i, createElementVNode as p } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconArrowDownLeftInCircleFilled",
  __name: "IconArrowDownLeftInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (s, e) => (l(), n(a(m), c(r, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        p("path", { d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12m5.636 2.864a1.25 1.25 0 0 0 1.25 1.25h4.571a.75.75 0 0 0 0-1.5h-3.26L15.53 9.53a.75.75 0 1 0-1.06-1.06l-5.084 5.084v-3.261a.75.75 0 0 0-1.5 0v4.571" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
